import { PicksRequest } from '@cds/query-objects';

import { BetslipGroupInformation } from '../../../../core/groups/betslip-group-information';
import { V2OptionMarketPickId, V2OptionMarketXCastPickId } from '../../../../core/picks/pick-id';
import { PickRequestBuilder } from './pick-request.builder';

export class V2OptionMarketPickRequestBuilder implements PickRequestBuilder<V2OptionMarketPickId> {
    getPickDataRequest(id: V2OptionMarketPickId, request: PicksRequest, _: boolean, groupInfo?: BetslipGroupInformation) {
        request.tv2Picks.push({
            fixtureId: id.fixtureId,
            optionMarketId: id.optionMarketId,
            isClassicBetBuilder: false,
            optionId: id.optionId,
            ...(!!groupInfo && { pickGroupId: groupInfo?.groupId }),
        });
    }
}
export class V2OptionMarketXCastPickRequestBuilder implements PickRequestBuilder<V2OptionMarketXCastPickId> {
    getPickDataRequest(id: V2OptionMarketXCastPickId, request: PicksRequest, _: boolean, groupInfo?: BetslipGroupInformation) {
        request.tv2Picks.push({
            fixtureId: id.fixtureId,
            optionMarketId: id.optionMarketId,
            isClassicBetBuilder: false,
        });
    }
}
